import Accordion from 'react-bootstrap/Accordion';
import styles from './faq.module.css';
import React from "react";

function FAQ() {
    return (
        <section className={styles.section_container}>
            <h2 className={styles.section_title}>
                Foire aux questions
            </h2>
            <div className={styles.content_wrapper}>
                <div className={styles.accordion_grid}>
                    <div className={styles.accordion_item_wrapper}>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Quel sont les repas que vous fournissez?</Accordion.Header>
                                <Accordion.Body>
                                    Nous préparons des repas maison frais, offrant une alimentation riche en
                                    nutriments qui favorise l'acquisition d'habitudes alimentaires santé et équilibrées,
                                    suivant le Guide alimentaire canadien
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                    <div className={styles.accordion_item_wrapper}>
                        <Accordion>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Accordion Item #2</Accordion.Header>
                                <Accordion.Body>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua...
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                    {/* Add more items here as needed */}
                </div>
            </div>
        </section>
    );
}

export default FAQ;
